<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
            <Button label="차트" icon="pi pi-chart-line" class="p-button-secondary mr-2" @click="chartPopup($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <InputText id="userId" type="text" v-model.trim="searchParams.userId" @keydown.enter="btnAct('SEARCH')" style="width:10em"/>
                        <label for="userId">사용자아이디</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="userNm" type="text" v-model.trim="searchParams.userNm" @keydown.enter="btnAct('SEARCH')"  style="width:10em"/>
                        <label for="userNm">사용자명</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto mr-2" style="width: 1rem">
                        <label>~</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>종료일자</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>  

        <Splitter style="height: 79vh">
            <SplitterPanel :size="35">
                <DataTable id="dt2" ref="dt2" :value="dataList2" class="p-datatable-sm" scrollHeight="74vh"
                    :scrollable="true" :loading="loading" scrollDirection="both" rowIndexVar="rowIndex"
                    :metaKeySelection="true" v-model:selection="selectedItems" 
                    :paginator="true" :rows="15" 
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    responsiveLayout="scroll" @row-click="onRowClick($event)" :rowClass="rowCheckClass"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <template #header>
                        <i class="pi pi-list" style="padding:5px"></i>
                        <span>날짜별 로그인로그</span>
                    </template>
                    <Column field="id" header="ID" :sortable="true" hidden></Column>
                    <Column field="loginDate2" header="로그인 날짜" :sortable="true"></Column>
                    <Column field="totUser" header="사용자 수" :sortable="true" ></Column>
                    <Column field="totUsageTime2" header="사용시간 합계" :sortable="true"></Column>
                    <Column field="totUsageTime" header="사용시간 합계2" :sortable="true" hidden></Column>
                </DataTable>
            </SplitterPanel>

            <SplitterPanel :size="65">
                <DataTable id="dt" ref="dt" :value="dataList" class="p-datatable-sm" scrollHeight="74vh"
                    rowIndexVar="rowIndex" :loading="loading" :virtualScrollerOptions="{ itemSize: 40 }" 
                    stateStorage="local" stateKey="dt-state-demo-local" responsiveLayout="scroll">
                    <template #header>
                        <i class="pi pi-list" style="padding:5px"></i>
                        <span>상세 로그인로그</span>
                    </template>
                    <Column field="rowNo" header="NO"></Column>
                    <Column field="loginDate2" header="로그인 날짜"></Column>
                    <Column field="userId" header="사용자ID" :sortable="true" ></Column>
                    <Column field="userNm" header="사용자이름" :sortable="true"></Column>
                    <Column field="usageTime2" header="사용시간" :sortable="true"></Column>
                </DataTable>
            </SplitterPanel>
        </Splitter>

        <Dialog :visible="chartPopupVisible" :style="{width: '1500px'}" :contentStyle="{height: '6500px'}" :closable="false">
                <h2 style="text-align: center;">일일 로그인 로그 집계</h2>

                <div class="card" style=" width:99%; height:99%; padding:0; margin:0;">
                    <vue-highcharts
                        type="chart"
                        :options="bar_chartOptions"
                        :redrawOnUpdate="true"
                        :oneToOneUpdate="false"
                        :animateOnUpdate="true"
                        style="display:block; height: 95%; width:100%;"
                        />
                </div>

            <template #footer>
                <Button label="닫기" icon="pi pi-check" @click="closeDialog" />
            </template>
        </Dialog>

    </div>
</template>

<script>
import { ref, onMounted, reactive , computed} from 'vue';
import DailyLoginLogService from '@/service/cm/DailyLoginLogService';
import JsUtils from '@/utilities/JsUtils';
import { useToast } from 'primevue/usetoast';

export default {
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;

            let date = new Date();  
            let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.fromDate = JsUtils.getDateString(fromDate);
            searchParams.toDate = JsUtils.getDateString(new Date());
        })
        const searchParams = reactive({userId:null,userNm:null,fromDate:null,toDate:null});
        const searchParams2 = reactive({userId:null,userNm:null,fromDate:null,toDate:null});
        const dataList = ref([]);
        const dataList2 = ref([]);
        const dt = ref();
        const dt2 = ref();

        const toast = useToast();

        // 차트
        const chartPopupVisible = ref(false);
        const chartData = ref([{}]);
        const charBarData = ref([{}]);
        const splineData = ref([{}]);

		const DailyLogService = new DailyLoginLogService();

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        searchList();
                    break;
            }
        }

        const searchList = () => {
            searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);

            DailyLogService.getList2(searchParams).then(data=> {
                dataList2.value = data;
            });
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, dataList.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(dataList.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // 날짜 포맷 수정
        const formatToYMD = (value = '') => {
            return `${value.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')}`
        }

         // 차트 팝업
        const chartPopup = () => {
            if(dataList2.value.length === 0){
                toast.add({severity:'warn', summary:'데이터 확인', detail:'Daily로그인로그 정보를 먼저 검색 후 차트를 확인 할 수 있습니다.', life:2000});
            }else{
                chartPopupVisible.value = true;

                chartData.value = getDataTableTo(dataList2.value,"loginDate2");
                charBarData.value = getDataTableToMultiBar(dataList2.value,"totUsageTime");
                splineData.value = getDataTableToSpline(dataList2.value,"totUser");
            }
        }

        // 차트를 닫음
        const closeDialog = () => {
            chartPopupVisible.value = false;
        }

        // 시간을 나타냄.
        const formatToTime = (value) => {
            var num = Number(value).toFixed(0);
            var Time = Math.round(num/(60*60));
            return `${Number(Time).toLocaleString()}`;
        }

        // 분 단위를 나타냄.
        const formatToTime2 = (value) => {
            var num = Number(value).toFixed(0);
            var min = parseInt((num%3600)/60);
            return `${Number(min).toLocaleString()}`;
        }

        // 차트 옵션 처리 
        const bar_chartOptions = computed(() => ({
            chart: {
                zoomType: 'xy',
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: chartData.value,
                crosshair: true
            },
            yAxis: [{
                title: {
                    text: '사용시간',
                },
                labels: {
                    formatter: function() {
                        return formatToTime(this.value)+ "시";
                    },
                },
            },{
                title: {
                    text: '사용자수',
                },
                labels: {
                    formatter: function() {
                        return this.value+ "명";
                    },
                },
                opposite: true
            }],
            tooltip: {
                formatter: function() {
                                let s;
                                s = this.point.name;
                                if(this.series.name == '사용시간') {
                                    s += '<br/><span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ':' 
                                    + formatToTime(this.point.y) + '시' + formatToTime2(this.point.y) + '분';
                                } else {
                                    s += '<br/><span style="color:' + this.point.color + '">\u25CF</span>'+ this.series.name + ':' 
                                    + this.point.y + '명';
                                }
                            return s;
                            }
            },
            series: [{
                    name: '사용시간',
                    type: 'column',
                    data:charBarData.value,
                    tooltip: {
                        formatter: function() {
                                let s;
                                s = this.point.name;
                                s += '<br/><span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ':' 
                                + formatToTime(this.value) + '시' + formatToTime2(this.value) + '분';
                            return s;
                            }
                        },
                },{
                    name: '사용자수',
                    type: 'spline',
                    yAxis: 1,
                    data:splineData.value,
                    tooltip: {
                       valueSuffix: ' 명'
                    }
            }],
            credits: {//워터마크 제거
                enabled: true
            },
        }));
        
        //차트 막대 데이터 가공처리
        const getDataTableTo = (obj,loginDate2) => {
            var ut = [];

            //alert(JSON.stringify(obj));
            for(let key=obj.length-1; key>=0; key--){
                ut[key] = obj[key][loginDate2];
                //alert(ut[key]);
            }
            return ut;
        };

        const getDataTableToMultiBar = (obj,totUsageTime) => {
            var ut = [];

            for(let key=obj.length-1; key>=0; key--){
                ut[key] = obj[key][totUsageTime];
            }
            return ut;
        };

        const getDataTableToSpline = (obj,totUser) => {
            var tu = [];

            for(let key=obj.length-1; key>=0; key--){
                tu[key] = obj[key][totUser];
            }
            return tu;
        }

        /** 행 클릭 이벤트
        * 현재 클릭한 행의 인덱스를 저장해둠
        * @default 0
        * @param {event} event 
        */

        const onRowClick = (event) => {

            searchParams2.userId = searchParams.userId;
            searchParams2.userNm = searchParams.userNm;
            searchParams2.fromDate = event.data.loginDate2;
            searchParams2.toDate = event.data.loginDate2;

            dataList2.value.forEach(row => {
                    row.click = 'N';
                });
                event.data.click = 'Y';

            DailyLogService.getList(searchParams2).then(data=> {
                dataList.value = data;
            });
        }

        const rowCheckClass = (data) => {
            return [{ 'bg-primary-200': data.click === 'Y' }, { 'bg-normal': data.click !== 'Y' }];
        }

        return { 
            dt, dt2, dataList, dataList2, searchParams, formatToYMD, formatToTime, formatToTime2, onRowClick, searchParams2,
            btnAct, downloadExcel, exportCSV, chartPopup, bar_chartOptions, closeDialog, chartPopupVisible, rowCheckClass
        }

    }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
